<template>
  <a :href="computedUrl" target="_blank">
    <BaseIcon
      :icon="icon"
      small
      :tooltipText="tooltipText"
    />
  </a>
</template>

<script>
import BaseIcon from '@/components/_buttons/BaseIcon.vue';

export default {
  name: 'HelpIcon',
  components: { BaseIcon },
  props: {
    // Parent now passes article IDs (or unique parts) for each language.
    urls: {
      type: Object,
      required: true
      // Example: { de: '41060331', en: '192282755', ko: '176881668', ja: '12345678' }
    },
    tooltipText: {
      type: String,
      default: 'Help'
    },
    icon: {
      type: String,
      default: 'fa-question-circle'
    }
  },
  computed: {
    computedUrl() {
      const lang = this.$i18n.locale; // Get the current language
      // Define the base URL for each language.
      const baseUrls = {
        de: 'https://alvdigital.atlassian.net/servicedesk/customer/portal/1/article/',
        en: 'https://alvdigital.atlassian.net/servicedesk/customer/portal/1/article/',
        ko: 'https://alvdigital.atlassian.net/servicedesk/customer/portal/1/article/',
        ja: 'https://alvdigital.atlassian.net/servicedesk/customer/portal/1/article/'
      };
      let articleId, baseUrl;
      if (lang === 'en') {
        // If an English article is not provided, fall back to German.
        articleId = this.urls.en || this.urls.de;
        baseUrl = baseUrls.en || baseUrls.de;
      } else {
        // For non-English, try the current locale, then English, then German.
        articleId = this.urls[lang] || this.urls.en || this.urls.de;
        baseUrl = baseUrls[lang] || baseUrls.en || baseUrls.de;
      }
      return baseUrl + articleId;
    }
  }
};
</script>
